import { Box, Button, Grid, Slide, Typography } from "@material-ui/core";
import React, { useEffect } from "react";
import { Order, ExecutionType } from "../../../Shared/GeneratedTypes";
import useInterval from "../../../Shared/useInterval";
import { DateTime } from "luxon";
import { EmptyGuid, Localizations } from "../../../Shared/sharedTypes";
import Util from "../../../Shared/utilties";

interface propsType {
    changeSchedule: () => void;
    enterQueue: () => void;
    checkQueuePlacement: () => void;
    placeInLine: number | null;
    customerPhotoUrl: string;
    order: Order;
    meetMentor: () => void;
    localizations: Localizations;
}

export default function WaitingQueue({
    customerPhotoUrl,
    placeInLine,
    changeSchedule,
    enterQueue,
    meetMentor,
    checkQueuePlacement,
    order,
    localizations,
}: propsType) {
    useEffect(() => {
        enterQueue();
    }, []);

    useEffect(() => {
        if (
            order.mentorActiveSince &&
            order.mentorActiveSince instanceof DateTime &&
            order.mentorActiveSince.diff(DateTime.local(), "minutes").minutes > -5 &&
            order.assignedMentor &&
            order.assignedMentor.id !== EmptyGuid
        ) {
            console.log(
                "Moving to meet your mentor",
                order.mentorActiveSince,
                DateTime.local(),
                order.mentorActiveSince.diff(DateTime.local(), "minutes")
            );
            meetMentor();
        }
    }, [order]);

    useInterval(checkQueuePlacement, 10000);

    return (
        <>
            <Grid
                item
                className="transparentBackground"
                container
                style={{ flex: 1, backgroundColor: "#85C441AA", padding: "24px 24px" }}
            >
                <Box p={4} borderRadius={20} textAlign="center" style={{ backgroundColor: "white", flex: 1 }}>
                    <img
                        src={customerPhotoUrl}
                        alt="carrier logo"
                        style={{
                            marginTop: 12,
                            marginBottom: 12,
                            maxHeight: "150px",
                            maxWidth: "90%",
                            // filter: "drop-shadow(rgba(200, 200, 200, 0.5) 3px 2px 11px)",
                        }}
                    />

                    <Typography variant="body1">
                        {Util.format(localizations.waitingQueueSaluation, { firstName: order.contact.firstName })}
                    </Typography>

                    {order.customer.useQueueSystem && (
                        <>
                            <Box m={1}>
                                <Typography variant="h5" align="center">
                                    {localizations.yourPlaceInLine}
                                </Typography>
                            </Box>
                            <Slide in direction="left">
                                <Typography variant="h2" color="primary" align="center" style={{ fontWeight: "bold" }}>
                                    #{placeInLine}
                                </Typography>
                            </Slide>
                        </>
                    )}

                    {(order.executionType === ExecutionType.Scheduled ||
                        order.executionType === ExecutionType.ExternallyScheduled) && (
                            <>
                                <Typography variant="body1" style={{ marginBottom: 5 }}>
                                    {localizations.scheduleTime}
                                </Typography>
                                <Typography
                                    variant="body1"
                                    color="primary"
                                    style={{ marginBottom: 10, fontWeight: "bold", fontSize: "1.1em" }}
                                >
                                    {order.scheduledDate &&
                                        (order.scheduledDate as DateTime)
                                            .toLocal()
                                            .toLocaleString(DateTime.TIME_WITH_SHORT_OFFSET)}
                                </Typography>
                            </>
                        )}
                    {order.executionType === ExecutionType.Scheduled && (
                        <Button variant="contained" color="primary" onClick={() => changeSchedule()}>
                            {localizations.reschedule}
                        </Button>
                    )}
                </Box>
            </Grid>
        </>
    );
}
